<template>
  <div class="page-body mt-3 position-relative">
    <AgeGroupTable
        @getRequestParams="getAgeGroupReportJobList"
        :list-job-data="listAgeGroupJobData"
        :total-rows="totalRows"
    />

    <div v-if="isLoading" class="table-overlay">
      <v-progress-circular
          :size="50"
          :width="5"
          color="primary"
          indeterminate
      />
    </div>
  </div>
</template>


<script>
import JobTable from "@/views/Reports/MetricsUtils/JobTable.vue";
import AgeGroupTable from "@/views/Reports/MetricsUtils/AgeGroupTable.vue";
import ReportService from "services/api/report.service";
import moment from "moment";

export default {
  components: { JobTable,AgeGroupTable },
  data() {
    return {
      listAgeGroupJobData: [],
      totalRows: 0,
      isLoading: false,
      jobRequestParams: {
        currentPage: 1,
        limit: 10,
        sortColumn: "",
        sortType: "",
        key: "",
        brandCode: "",
        type: "AGE_GROUP",
      },
    };
  },
  methods: {
    getAgeGroupReportJobList(params) {
      this.isLoading = true;
      this.jobRequestParams = { ...params, type: "AGE_GROUP" };
      this.getReportJobData();
    },
    getReportJobData() {
      ReportService.getReportJobs(this.jobRequestParams)
          .then((res) => {
            const data = res.data;
            this.totalRows = data.totalItems;
            this.listAgeGroupJobData = data.reportJobs.map((c) => {
              let formattedCRMFilter = "";
              const requestCRMFilterObj = JSON.parse(c.request);
              Object.entries(requestCRMFilterObj).forEach(([key, value]) => {
                let displayValue = value;

                if (Array.isArray(value)) {
                  displayValue = value.length ? value.join(", ") : "-";
                }

                formattedCRMFilter += `${key}: ${displayValue}\n`;
              });

              return {
                ...c,
                status: c.status.charAt(0).toUpperCase() + c.status.slice(1),
                dateCreated: moment(c.dateCreated).format("YYYY-MM-DD HH:mm:ss"),
                request: formattedCRMFilter,
              };
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.error("Error: ", err);
            this.isLoading = false;
          });
    },
    reload() {
      this.isLoading = true;
      this.getReportJobData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-body {
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.table-overlay {
  position: absolute;
  inset: 0;
  margin-top: 200px;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 10;
}
</style>